var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"case-tabs"},[_c('router-link',{attrs:{"to":"/ured"}},[_c('div',{class:['case-tab case-tab-osobe', _vm.active_link == 0 ? 'active':'']},[_vm._v(_vm._s(_vm.$t('office_management.navigation.quick_purchase')))])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }